var bugsnag = require('@bugsnag/js');

var bugsnagVue = require('@bugsnag/plugin-vue');

export default (function (_ref) {
  var Vue = _ref.Vue;

  if (process.env.NODE_ENV === 'production') {
    var bugsnagClient = bugsnag('8b22988898e6a4d240aedcb3999b644e');
    bugsnagClient.use(bugsnagVue, Vue);
  }
});